import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { OPEN_CONSENT_EVENT, getConsent, loadAnalytics, setConsent } from "@/lib/analytics";

/**
 * Baner zgody na cookies analityczne (Google Analytics). Pokazuje się, dopóki odwiedzający nie wybierze;
 * „Ustawienia cookies” w stopce otwiera go ponownie. Oba przyciski są równorzędne.
 */
export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const stored = getConsent();
    if (stored === "granted") loadAnalytics();
    if (!stored) setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener(OPEN_CONSENT_EVENT, reopen);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, reopen);
  }, []);

  const choose = (value) => { setConsent(value); setOpen(false); };

  if (!open) return null;
  return (
    <div role="region" aria-labelledby="cookie-consent-title" data-testid="cookie-consent"
      className="hero-dark fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-3xl rounded-2xl border border-white/10 bg-[#0b0b10]/95 p-5 shadow-2xl backdrop-blur md:bottom-6 md:p-6"
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}>
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
        <div className="min-w-0 flex-1">
          <p id="cookie-consent-title" className="flex items-center gap-2 font-display text-base font-bold text-white">
            <Cookie className="h-4 w-4 text-[var(--brand-accent)]" aria-hidden="true" /> Cookies analityczne
          </p>
          <p className="mt-1.5 text-sm leading-relaxed text-zinc-300">
            Za Twoją zgodą używamy Google Analytics, żeby wiedzieć, które strony są odwiedzane i co warto poprawić. Bez zgody strona działa tak samo. Szczegóły w <Link to="/polityka-prywatnosci" className="underline">polityce prywatności</Link>.
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <button type="button" onClick={() => choose("denied")} data-testid="cookie-reject"
            className="min-h-11 flex-1 rounded-full border border-white/20 px-5 py-2.5 text-sm font-semibold text-white hover:border-white/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400 md:flex-none">
            Odrzucam
          </button>
          <button type="button" onClick={() => choose("granted")} data-testid="cookie-accept"
            className="min-h-11 flex-1 rounded-full border border-white/20 bg-white px-5 py-2.5 text-sm font-semibold text-zinc-950 hover:bg-zinc-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400 md:flex-none">
            Akceptuję
          </button>
        </div>
      </div>
    </div>
  );
}
